export default {
  COLLECTIONS: '',
  FIND_DEALER: 'car-dealers',
  FIND_CAR: 'cars-for-sale',
  MARKETPLACE: 'marketplace',
  MY_CAR: 'my-autotrader',
  SELL_CAR: 'sell-my-car',
  FIND_DEALER_KBB: 'dealers'
};